import React, { useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getUserSubsPlanStart } from "store/SuperAdmin/Authentication/Users/action"
import TableContainer from "components/Common/TableContainer"
import Loader from "common/Loader"
import moment from "moment"
import { CardBody, Col, Row, Badge, Card } from "reactstrap"
import BackButton from "components/Common/BackButton"
const Home = () => {
  const { loading, usersSubscriptionPlan } = useSelector(
    state => state.SuperUser
  )
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getUserSubsPlanStart())
  }, [])

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Phone No.",
        accessor: "phone_no",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Start Date",
        accessor: "start_date",
        Cell: cellProps => {
          return <>{moment(cellProps.value).format("DD-MM-YYYY")}</>
        },
      },
      {
        Header: "Expiry Date",
        accessor: "expiry_date",
        Cell: cellProps => {
          return <>{moment(cellProps.value).format("DD-MM-YYYY")}</>
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: cellProps => {
          return <>  {cellProps.row.original.status === "active" ? (
            <Badge className={"badge-soft-success"}>Active</Badge>
          ) : cellProps.row.original.status === "Renewed" ? (
            <Badge className={"badge-soft-info"}>Renewed</Badge>
          ) : cellProps.row.original.status === "inactive" ? (
            <Badge className={"badge-soft-danger"}>Inactive</Badge>
          ) : null}</>
        },
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Payment Mode",
        accessor: "payment_mode",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
    ],
    []
  )
  return (
    <div>
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              {loading ? (
                <Loader />
              ) : (
                <div>
                  <Card>
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <h1 className="mb-0 card-title flex-grow-1">
                          User Subscription
                        </h1>
                        <BackButton/>

                      </div>
                    </CardBody>
                    <CardBody>
                      <TableContainer
                        columns={columns}
                        data={usersSubscriptionPlan?.data || []}
                        isGlobalFilter={true}
                        isAddOptions={false}
                        // handleJobClicks={handleJobClicks}
                        isJobListGlobalFilter={false}
                        isPagination={true}
                        iscustomPageSizeOptions={true}
                        isShowingPageLength={true}
                        customPageSize={10}
                        tableClass="table-bordered align-middle nowrap mt-2"
                        paginationDiv="col-sm-12 col-md-7"
                        pagination="pagination justify-content-end pagination-rounded"
                      />
                    </CardBody>
                  </Card>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default Home
